import { render, staticRenderFns } from "./RegisterUserInfo.vue?vue&type=template&id=b166e58a&scoped=true&"
import script from "./RegisterUserInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUserInfo.vue?vue&type=style&index=0&id=b166e58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b166e58a",
  null
  
)

export default component.exports